/**
 * Nordic Saw chipload calculator
 * IPT = (feed * unitFactor) / (RPM * flutes)
 * unitFactor: 1 for IPM, 39.37007874 for m/min
 */
(function () {
  var root = document.querySelector('[data-ns-chipload]');
  if (!root) return;

  var modeWrap = root.querySelector('[data-mode-wrap]');
  var feedField = root.querySelector('[data-feed-field]');
  var chiploadField = root.querySelector('[data-chipload-field]');
  var feed = root.querySelector('[data-feed]');
  var target = root.querySelector('[data-target]');
  var units = root.querySelector('[data-units]');
  var rpm = root.querySelector('[data-rpm]');
  var flutes = root.querySelector('[data-flutes]');
  var out = root.querySelector('[data-out]');
  var outUnit = root.querySelector('[data-out-unit]');
  var resultLabel = root.querySelector('[data-result-label]');
  var resultHint = root.querySelector('[data-result-hint]');
  var mode = 'chipload';
  var UNIT_IPM = 1;
  var UNIT_MPM = 39.37007874;

  function unitFactor() {
    return units.value === 'mpm' ? UNIT_MPM : UNIT_IPM;
  }

  function calc() {
    var r = Number(rpm.value);
    var f = Number(flutes.value);
    if (!(r > 0) || !(f > 0)) {
      out.textContent = '—';
      return;
    }
    var uf = unitFactor();
    if (mode === 'chipload') {
      var cl = (Number(feed.value) * uf) / (r * f);
      out.textContent = isFinite(cl) ? cl.toFixed(3) : '—';
      outUnit.textContent = 'in / tooth';
      resultLabel.textContent = 'Your chipload';
      resultHint.textContent = 'Feed ÷ (RPM × flutes)';
    } else {
      var shown = (Number(target.value) * r * f) / uf;
      out.textContent = isFinite(shown) ? shown.toFixed(1) : '—';
      outUnit.textContent = units.value === 'mpm' ? 'm / min' : 'in / min';
      resultLabel.textContent = 'Suggested feed';
      resultHint.textContent = 'Chipload × RPM × flutes';
    }
  }

  modeWrap.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mode]');
    if (!btn) return;
    mode = btn.getAttribute('data-mode');
    modeWrap.querySelectorAll('[data-mode]').forEach(function (b) {
      b.classList.toggle('on', b === btn);
    });
    feedField.hidden = mode !== 'chipload';
    chiploadField.hidden = mode !== 'feed';
    calc();
  });

  [feed, target, units, rpm, flutes].forEach(function (el) {
    el.addEventListener('input', calc);
  });
  units.addEventListener('change', calc);
  calc();
})();
